import {
  type AutomationTemplateId,
  AutomationTemplateIds,
} from "@repo/app-types/entities/automation";
import { SimpleModal, SimpleModalVariant } from "@repo/ui/Modal/modal";
import type { FC } from "react";

const deleteConsequencesByTemplate: Record<AutomationTemplateId, string> = {
  [AutomationTemplateIds.TEAMMATE_COACHING]:
    "Future coaching goal notifications will stop. Coaching focus notes saved in this automation will no longer shape the goals shown on teammate profiles.",
  [AutomationTemplateIds.PLAYBOOK_SCORE_MOVEMENT]:
    "This automation will stop sending future notifications.",
  [AutomationTemplateIds.PLAYBOOK_FEEDBACK_ALERT]:
    "This automation will stop sending future notifications.",
  [AutomationTemplateIds.LEAD_BURNING]:
    "This automation will stop sending future notifications.",
  [AutomationTemplateIds.CUSTOMER_PRAISE_DIGEST]:
    "This automation will stop sending future notifications.",
  [AutomationTemplateIds.CUSTOM]:
    "This automation will stop sending future notifications.",
};

export interface DeleteAutomationModalProps {
  isOpen: boolean;
  templateId: AutomationTemplateId;
  onCancel: () => void;
  onDelete: () => void;
}

export const DeleteAutomationModal: FC<DeleteAutomationModalProps> = (
  props,
) => {
  const { isOpen, templateId, onCancel, onDelete } = props;
  return (
    <SimpleModal
      isOpen={isOpen}
      onCancel={onCancel}
      variant={SimpleModalVariant.Warning}
      title="Delete automation?"
      subtitle={deleteConsequencesByTemplate[templateId]}
      confirmButtonText="Delete automation"
      onConfirm={onDelete}
    />
  );
};
